export const categories = state => state.activities.categories;
